import type { UseQueryOptions } from 'react-query';
import { useQuery } from '@frontend/react-query-helpers';
import {
  getStripePaymentMethodId,
  type GetStripePaymentMethodIdProps,
  type GetStripePaymentMethodIdResponse,
} from '../requests/get-stripe-payment-method-id';
import { paymentMethodQueryKeys } from './keys';

export const useGetStripePaymentMethodId = (
  request: GetStripePaymentMethodIdProps,
  options?: UseQueryOptions<GetStripePaymentMethodIdResponse>
) => {
  return useQuery({
    queryKey: paymentMethodQueryKeys.getStripePaymentMethodId(request),
    queryFn: () => getStripePaymentMethodId(request),
    ...options,
    enabled: options?.enabled !== false && !!request.locationId && !!request.paymentUuid,
  });
};
